import { init } from "./translationSlice";
import * as translationService from "../../../services/Translation";

export const fetchTranslations = () => async dispatch => {
    try {
        const resp = await translationService.getTranslations();
       
        dispatch(init(resp.data));
    } catch (err) {
        console.error(err);
        throw err;
    }
}